const state = () => ({
  trueName: "", //账号姓名
  userId: "", //用户id
  userName: '',//用户名
  phone: '',//用户登录后的账号
  sessionId: "", //sessionid
  fileSaveToGroup: "",
  loginType: '',//登录类型，在登陆成功后设置
  resetPassword: false, //#3045 被重置后的用户 登录后跳转到修改密码界面
  settings: {},// 用户设置
  groupData: {},//团队数据
  groupName: "", //团队名称
  groupUserId: "",//团队用户id
  groupTrueName: "", //团队里面的姓名
  groupLanguage: "",//语言
  alarmInformation: true, //团队设置的是否开启告警信息功能
  moduleConfig: {//系统中部分按钮的开关配置
    group: {//团队设置
      openHome: {
        open: true,//控制按钮开关
      },
      shoppingCart: {
        open: true
      },
      toDo: {
        open: true
      },
      alarmInformation: {
        open: true
      },
      alarmReminder: {
        open: true
      },
    },
    system: {//系统设置（暂未启用，后续有需求可以启用此配置）
      openHome: {
        open: true
      },
      shoppingCart: {
        open: true
      },
      toDo: {
        open: true
      },
      alarmInformation: {
        open: true
      },
      alarmReminder: {
        open: true
      },
    }
  },
  menuListAdmin: [], //管理菜单
  roles: [], //团队中的角色
  allRoles: [], //团队中的角色 #4237
  isGroupAdmin: false,//团队管理员
  isAdmin: false,//超级管理员
  organizations: {},//团队信息，包含title 和 _id
  urlNavMap: {}, //面包屑
  pageSize: 1,//页面缩放比例
})

// actions
const actions = {
  async setNameValue({ commit, state }, keyObj) {
    commit('setNameValue', keyObj)
  },
  async clearSystemManage({ commit, state }, keyObj) {
    commit('clearSystemManage', keyObj)
  },
}

// mutations
const mutations = {
  setNameValue(state, keyObj) {
    state[keyObj.name] = keyObj.value
  },
  clearSystemManage(state) {
    let origanel = {
      trueName: "", //账号姓名
      userId: "", //用户id
      userName: '',//用户名
      phone: '',//用户登录后的账号
      sessionId: "", //sessionid
      fileSaveToGroup: "",
      loginType: '',//登录类型，在登陆成功后设置
      resetPassword: false, //#3045 被重置后的用户 登录后跳转到修改密码界面
      settings: {},// 用户设置
      groupData: {},//团队数据
      groupName: "", //团队名称
      groupUserId: "",//团队用户id
      groupTrueName: "", //团队里面的姓名
      groupLanguage: "",//语言
      alarmInformation: true, //团队设置的是否开启告警信息功能
      moduleConfig: {//系统中部分按钮的开关配置
        group: {//团队设置
          openHome: {
            open: true,//控制按钮开关
          },
          shoppingCart: {
            open: true
          },
          toDo: {
            open: true
          },
          alarmInformation: {
            open: true
          },
          alarmReminder: {
            open: true
          },
        },
        system: {//系统设置（暂未启用，后续有需求可以启用此配置）
          openHome: {
            open: true
          },
          shoppingCart: {
            open: true
          },
          toDo: {
            open: true
          },
          alarmInformation: {
            open: true
          },
          alarmReminder: {
            open: true
          },
        }
      },
      menuListAdmin: [], //管理菜单
      roles: [], //团队中的角色
      allRoles: [], //团队中的角色 #4237
      isGroupAdmin: false,//团队管理员
      isAdmin: false,//超级管理员
      organizations: {},//团队信息，包含title 和 _id
      urlNavMap: {}, //面包屑
      pageSize: 1,//页面缩放比例
    }
    for (let key in origanel) {
      state[key] = origanel[key]
    }
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}